<template>
  <g>
    <defs>
      <path
        id="maps@1x-a"
        d="M19.4560054,6.64024508 L14.6560054,5.04024508 L14.6000054,5.04024508 C14.5627658,5.03650236 14.5252449,5.03650236 14.4880054,5.04024508 L14.3040054,5.04024508 L14.2000054,5.04024508 L14.1440054,5.04024508 L9.60000536,6.60024508 L5.05600536,5.04024508 C4.81194697,4.95976846 4.54408593,5.00143573 4.33600536,5.15224508 C4.1262489,5.30158574 4.00119601,5.54275918 4.00000267,5.80024508 L4.00000267,17.0002451 C3.99911755,17.3441778 4.21815599,17.6501874 4.54400536,17.7602451 L9.34400536,19.3602451 L9.34400536,19.3602451 C9.50516341,19.4127928 9.67884732,19.4127928 9.84000536,19.3602451 L9.84000536,19.3602451 L14.4000054,17.8402451 L18.9440054,19.4002451 C19.0289495,19.4117708 19.1150612,19.4117708 19.2000054,19.4002451 C19.3672732,19.4025978 19.5305503,19.3491104 19.6640054,19.2482451 C19.8737618,19.0989044 19.9988147,18.857731 20.0000027,18.6002451 L20.0000027,7.40024508 C20.0008932,7.05631235 19.7818547,6.75030277 19.4560054,6.64024508 Z M8.80000536,17.4882451 L5.60000536,16.4242451 L5.60000536,6.91224508 L8.80000536,7.97624508 L8.80000536,17.4882451 Z M13.6000054,16.4242451 L10.4000054,17.4882451 L10.4000054,7.97624508 L13.6000054,6.91224508 L13.6000054,16.4242451 Z M18.4000054,17.4882451 L15.2000054,16.4242451 L15.2000054,6.91224508 L18.4000054,7.97624508 L18.4000054,17.4882451 Z"
      />
    </defs>
    <g fill="none" fill-rule="evenodd">
      <rect
        width="24"
        height="24"
        fill="#E3E3E3"
        fill-opacity=".01"
        style="mix-blend-mode:color-burn"
      />
      <use :fill="currentColor" :opacity="opacity" fill-rule="nonzero" xlink:href="#maps@1x-a" />
    </g>
  </g>
</template>

<script>
  export default {
    props: {
      currentColor: {
        type: String,
        default: 'black'
      },
      opacity: {
        type: String,
        default: '1'
      }
    }  
  }
</script>